// AI选股
import stubStrategy from '@/views/ai_stock/stub_strategy/index.vue' // 短线策略

const routes = [
    {
        path: '/stubStrategy',
        name: 'stubStrategy',
        component: stubStrategy,
        meta: {
            title: '益学堂-短线策略',
        },
    },
]

export default routes;